module.exports = __webpack_public_path__ + "static/media/home_japan_main4.611ff7b5.svg";